<template>
<div class="post-cooldown">
    <label class="label">Post Cooldown</label>
    <p class="help">
        The amount of time a user must wait until they can post again.
    </p>
    <div class="field is-grouped is-grouped-multiline">
        <div class="control">
            <div class="field">
                <label class="label">Hours</label>
                <div class="control">
                    <input
                        v-model.number="hours"
                        class="input"
                        type="number"
                        min="0"
                        max="99"
                        placeholder="24"
                        required/>
                </div>
            </div>
        </div>
        <div class="control">
            <div class="field">
                <label class="label">Minutes</label>
                <div class="control">
                    <input
                        v-model.number="minutes"
                        class="input"
                        type="number"
                        min="0"
                        max="59"
                        placeholder="0"
                        required/>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'PostCooldown',
    props: {
        value: Number
    },
    data: vm => {
        const { hours, minutes } = vm.getHoursAndMinutesFromCooldown(vm.value)
        return { hours, minutes }
    },
    computed: {
        totalMinutes () {
            return (this.hours * 60) + this.minutes
        }
    },
    watch: {
        value () {
            const { hours, minutes } = this.getHoursAndMinutesFromCooldown(this.value)
            this.hours = hours
            this.minutes = minutes
        },
        totalMinutes () {
            this.$emit('input', this.totalMinutes)
        },
        hours () {
            if (!Number.isInteger(this.hours)) {
                this.hours = 0
            }
        },
        minutes () {
            if (!Number.isInteger(this.minutes)) {
                this.minutes = 0
            }
        }
    },
    methods: {
        getHoursAndMinutesFromCooldown (postCooldownMinutes) {
            const hours = this.getTotalHours(postCooldownMinutes)
            const minutes = this.getRemainingMinutes(postCooldownMinutes)
            return { hours, minutes }
        },
        getTotalHours (postCooldownMinutes) {
            return Math.floor(postCooldownMinutes / 60)
        },
        getRemainingMinutes (postCooldownMinutes) {
            return postCooldownMinutes % 60
        }
    }
}
</script>

<style lang="scss" scoped>
input[type="number"]{
    width: 65px;
}

.field .label {
    font-size: 0.85rem;
    font-weight: normal;
}
</style>
